import { mapState } from "vuex";
import {isArray} from "vue-resource/src/util";
export default {
  computed: {
    ...mapState({
      config: state => state.configurator.config,
      selectedOptions: state => state.configurator.selectedOptions,
      magentoData: state => state.configurator.magentoData,
      exportedImage: state => state.configurator.exportedImage
    })
  },
  methods: {
    createCartItem: function () {

      console.log(JSON.stringify(this.selectedOptions));
      let custom_options = [];
      for (let key of Object.keys(this.selectedOptions)) {
        let option = this.selectedOptions[key];
        console.log(option);
        let value = option.sku;
        if (option.previewMutations) {
          let front = option.previewMutations.front;
          if (isArray(front) && front[0].property === 'text') {
            value = option.value;
          }
        } else {
          value = option.value;
        }
        
        var optionIdValue  = key;
        if (optionIdValue.indexOf('-') != -1) {
          var optionIdArr = optionIdValue.split('-');
          var lastPart = optionIdArr[1];
          optionIdValue = optionIdArr[0] + lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
        }

        custom_options.push({
          optionId: optionIdValue,
          selectedValueId: value
        });
      }

      let formData = new FormData();
      formData.append('pid', this.magentoData.sku);
      formData.append('quantity', this.quantity || 1);
      formData.append('options', JSON.stringify(custom_options));
      formData.append('preview', this.exportedImage);
      return formData;

    },
    addCustomOptionFileToCartItem(value) {
      let fileType = value.match(/data:(.*);base64,/);
      fileType = fileType && fileType.length > 0 ? fileType[1] : null;
      const imgType = "." + fileType.split("/")[1];
      const fileName = this.magentoData.quoteId + "_" + this.config.product.sku + imgType;
      const base64Data = value.replace(/^data:image\/(png|jpg|jpeg|webp);base64,/, ""); // @TODO: different file types need to be defined in some configuration

      let previewImage = [];
      previewImage.push({
        base64_encoded_data: base64Data,
        type: fileType,
        name: fileName
      });

      return previewImage;
    },
  }
};
